<template>
     <div v-loading="loading">
        <oldApply v-if="version<5"></oldApply>
        <newApply v-else></newApply>
     </div>
</template>
<script>
import { chat2Ascii } from "../../static/js/util.js";
import oldApply from "./ApplyNow/apply.vue"
import newApply from "./ApplyNow/applyNew.vue"
export default {
    components:{
        oldApply,
        newApply
    },
    data() {
        return {
            loading:false,
            version:5
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        //如果是管理员进入，需要获取用户注册时候版本是否大于5，大于5进入新的申请页面，如果是新用户注册则一律用新的注册页面
        getData(){
            if(this.$route.query.model=='review'&&this.$route.query.verify){
                var email = this.$route.query.email
                var verify = this.$route.query.verify
                var verifyCode = chat2Ascii(email)
                // console.log('验证码是',verifyCode)
                if(verifyCode!=verify){
                    this.isAdmin=false
                    this.$router.push('/login')
                    return
                }
                this.isAdmin=true
                if(!email)return
                this.loading = true
                this.$axios.get(this.$URL.applyInfo,{params:{email:email}}).then(res=>{
                    this.loading = false
                    if(res.code==0){
                        this.version = res.data.version
                    }
                }).catch(err=>{
                    this.loading = false
                    this.$message.error({message:err})
                })
            }
        },
    },
    watch:{
        '$route'(to,from){
            if(to.path==='/apply'){
                this.getData()
            }
        }
    },
}
</script>